import { render, staticRenderFns } from "./AutoBarcodeSettings.vue?vue&type=template&id=26e34d8c"
import script from "./AutoBarcodeSettings.vue?vue&type=script&lang=ts"
export * from "./AutoBarcodeSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e34d8c')) {
      api.createRecord('26e34d8c', component.options)
    } else {
      api.reload('26e34d8c', component.options)
    }
    module.hot.accept("./AutoBarcodeSettings.vue?vue&type=template&id=26e34d8c", function () {
      api.rerender('26e34d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/AutoBarcodeSettings.vue"
export default component.exports